import React from 'react';
import { ImageResizeOptions } from 'wix-ui-tpa';

import { ImageCrop, ImageRatio, LayoutType } from 'settings/consts';

import { GroupCardMedia, GroupCardMediaProps } from '../media/GroupCardMedia';
import { ICoverSettings } from './IGroupCardSettings';

import { classes, st } from './Cover.st.css';

interface Props
  extends Omit<GroupCardMediaProps, 'ratio'>,
    Omit<ICoverSettings, 'showImage'> {
  groupListLayout: LayoutType;
  mobile?: boolean;
}

export const Cover: React.FC<Props> = ({
  groupListLayout,
  groupUrl,
  imageRatio,
  goToGroup,
  imageCrop,
  url,
  mobile,
}) => {
  const resize =
    imageCrop === ImageCrop.FIT
      ? ImageResizeOptions.contain
      : ImageResizeOptions.cover;

  return (
    <div
      className={st(classes.root, {
        ratio: imageRatio,
        layout: groupListLayout,
        mobile: mobile!,
      })}
    >
      <GroupCardMedia
        url={url}
        aspectRatio={imageRatio === ImageRatio.square ? 'square' : 'cinema'}
        groupUrl={groupUrl}
        goToGroup={goToGroup}
        resize={resize}
      />
    </div>
  );
};

Cover.displayName = 'Cover';
